import * as React from "react";
import * as d3 from "./assets/d3";
import { select } from "d3-selection";
import "./Xaxis.scss";
export default class Xaxis extends React.PureComponent {
    constructor(props) {
        super(props);
        const { scale, tickFormat, width, labelWidth } = this.props;
        const axis = d3
            .axisBottom(scale)
            .tickFormat(tickFormat)
            .ticks(Math.floor(width / labelWidth));
        this.state = {
            axis,
        };
    }
    updateAxisColor() {
        const { color } = this.props;
        const axisColor = color ? color : "black";
        select(this.arc)
            .call(this.state.axis)
            .selectAll("line")
            .attr("stroke", axisColor);
        select(this.arc)
            .call(this.state.axis)
            .selectAll("path")
            .attr("stroke", axisColor);
    }
    componentDidMount() {
        this.updateAxisColor();
    }
    componentDidUpdate() {
        const { scale, width, tickFormat, labelWidth } = this.props;
        select(this.arc).call(this.state.axis
            .scale(scale)
            .tickFormat(tickFormat)
            .ticks(Math.floor(width / labelWidth)));
        this.updateAxisColor();
    }
    render() {
        const { height, width, margins, title } = this.props;
        const t = `translate(0,${height + margins.top})`;
        return (React.createElement(React.Fragment, null,
            React.createElement("text", { transform: `translate(${width / 2 + margins.left} ,${height + margins.top + 40})`, style: { textAnchor: "middle" } }, title),
            React.createElement("g", { "data-testid": "horizontal-axis", className: "focus-grafos-x-axis", transform: t, ref: (ref) => {
                    this.arc = ref;
                } })));
    }
}
//# sourceMappingURL=Xaxis.js.map